// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__iu0mc","signatureButtonsRight":"ModalSign_signatureButtonsRight__q2f2x"};